import { render } from "./Comparison-image-slider.vue?vue&type=template&id=187113a8"
import script from "./Comparison-image-slider.vue?vue&type=script&lang=js"
export * from "./Comparison-image-slider.vue?vue&type=script&lang=js"

import "./Comparison-image-slider.vue?vue&type=style&index=0&id=187113a8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__